import { StatsDebuggerServiceInterface } from '../../service/stats-debugger/service.interface';
import { LoggerProviderInterface } from '@propertyfinder/pf-fe-logger';
import { StatsPlatformEnum } from './platform.enum';

export class StatsDebugger implements StatsDebuggerServiceInterface {
  /**
   * Is the debugger active ?
   */
  private isActive: boolean = false;

  /**
   * Constructor
   */
  constructor(private applicationLogger: LoggerProviderInterface) {}

  /**
   * @inheritDoc
   */
  public activate(isActive: boolean): void {
    this.isActive = isActive;
  }

  /**
   * @inheritDoc
   */
  public log(platform: StatsPlatformEnum, eventName: string, data: object): void {
    // Debugger not active
    if (this.isActive === false) {
      return;
    }

    // Generate message
    let message: string = '[stats][' + eventName + ']';

    if (platform) {
      message += '[' + platform + ']';
    }

    // Log message
    this.applicationLogger.info(message, data);
  }
}
